<template>
  <div class="categories-main-container">
    <span class="multiple-categories-container">
      <figure v-for="(category,index) in filteredCategories" class="categories-container" :data-balloon="category.name" data-balloon-pos="up-left" :key="index">
        <img v-if="category.image !== ''" :src="category.image" alt="Category Image">
      </figure>
    </span>
  </div>
</template>

<script>
export default {
  props: ['categories'],
  computed: {
    filteredCategories: function () {
      return this.categories.slice(0, 9)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .categories-main-container {
    width: 100%;
    margin: 0.25rem;
    display: flex;
    min-height: 1.5rem;
    @include touch {
      padding-left: 0.5rem;
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .categories-container {
    width: 1.5rem;
    height: 1.5rem;
    display: inline-block;
    z-index: 4;
    overflow: visible;
    @include mobile {
      width: 2rem;
      height: 2rem;
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .multiple-categories-container {
    .categories-container{
      position: relative;
    }
  }
</style>
